// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"9d8f44f4","82":"bf633f47","229":"dbb15b92","413":"ab0c0f51","623":"906649b6","624":"a8633c2c","820":"e88d97d5"}[chunkId] + ".css";
};